define('charts/basechart',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.BaseChart = void 0;
    var BaseChart = /** @class */ (function () {
        // Children are responsible for calling window.addEventListener("resize", () => update())
        // Children are also responsible for layers.overlay.on mousemove, mouseout
        function BaseChart(elementSelector, margin, axes) {
            // Axis stuff
            this.xAxis = {};
            this.yAxis = [];
            // SVG layers: axes, overlay, etc
            this.layers = {}; // TODO: Kill me
            // Managed chart layers
            this.chartlayers = [];
            this.margin = margin;
            // Create SVG
            this.div = d3.select(elementSelector);
            if (this.div.size() === 0) {
                console.error("Chart init missing div");
                return;
            }
            this.svg = this.div.append("svg");
            this.layers.svgg = this.svg.append("g")
                .attr("transform", "translate(" + this.margin.left + "," + this.margin.top + ")");
            // Add layers
            this.layers.space = this.layers.svgg.append("g")
                .attr("class", "plot-space");
            this.layers.axes = this.layers.space.append("g")
                .attr("class", "axes");
            // Setup axes
            this.xAxis.scale = d3.scaleLinear();
            this.xAxis.axis = d3.axisTop(this.xAxis.scale);
            this.xAxis.layer = this.layers.axes.append("g")
                .attr("class", "x axis");
            for (var i = 0; i < axes; i++) {
                this.yAxis[i] = {};
                this.yAxis[i].scale = d3.scaleLinear();
                this.yAxis[i].axis = d3.axisLeft(this.yAxis[0].scale);
                this.yAxis[i].layer = this.layers.axes.append("g")
                    .attr("class", "y axis");
            }
            // Listen for mouse movements
            this.layers.overlay = this.layers.svgg.append("rect")
                .attr("class", "overlay")
                .style("fill", "none");
        }
        // Update chart data
        // Children are responsible for updating xScale and yScale
        BaseChart.prototype.update = function () {
            if (this.svg === undefined)
                return console.error("Should not update without chart");
            var fullWidth = this.fullWidth();
            var fullHeight = this.fullHeight();
            var width = this.width();
            var height = this.height();
            // Update SVG bounds
            var shortSide = Math.min(fullWidth, fullHeight); // Short side of the rectangle
            this.svg
                .attr("width", fullWidth)
                .attr("height", fullHeight)
                .attr("viewBox", "0 0 " + shortSide + " " + shortSide)
                .attr("preserveAspectRatio", "xMinYMin");
            // Scale the range of the data
            this.xAxis.scale.range([0, width]);
            for (var _i = 0, _a = this.yAxis; _i < _a.length; _i++) {
                var yAxis = _a[_i];
                yAxis.scale.range([height, 0]);
            }
            var xTicks = this.xAxis.ticks || 1 + Math.floor(width / 100);
            this.xAxis.axis
                .tickSizeInner(this.xAxis.gridLines ? -height : 5)
                .tickSizeOuter(0)
                .ticks(xTicks);
            this.xAxis.layer
                .call(this.xAxis.axis);
            for (var _b = 0, _c = this.yAxis; _b < _c.length; _b++) {
                var yAxis = _c[_b];
                var yTicks = yAxis.ticks || 1 + Math.floor(height / 100);
                yAxis.axis
                    .tickSizeInner(yAxis.gridLines ? -width : 5)
                    .tickSizeOuter(0)
                    .ticks(yTicks);
                yAxis.layer
                    .call(yAxis.axis);
            }
            this.layers.overlay
                .attr("width", width)
                .attr("height", height);
            // Update managed layers
            for (var _d = 0, _e = this.chartlayers; _d < _e.length; _d++) {
                var layer = _e[_d];
                layer.update(this);
            }
        };
        // Managed layers
        BaseChart.prototype.addLayer = function (layer) {
            this.chartlayers.push(layer);
            if (this.svg === undefined)
                return console.error("Should not add layer without chart");
            layer.init(this);
        };
        BaseChart.prototype.removeLayer = function (layer) {
            this.chartlayers = this.chartlayers.filter(function (l) { return l !== layer; });
            layer.remove();
        };
        // Returns the width of the usable chart area, minus margin
        BaseChart.prototype.width = function () {
            return this.fullWidth() - this.margin.left - this.margin.right;
        };
        BaseChart.prototype.height = function () {
            return this.fullHeight() - this.margin.top - this.margin.bottom;
        };
        BaseChart.prototype.fullWidth = function () {
            return this.div.style("width").replace("px", "");
        };
        BaseChart.prototype.fullHeight = function () {
            return this.div.style("height").replace("px", "");
        };
        return BaseChart;
    }());
    exports.BaseChart = BaseChart;
});
//# sourceMappingURL=/assets/javascripts/charts/basechart.js.map;
